/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { CircularProgress } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { getExperienceSearchResults } from "utils/apiClients";
import { getSearchEventProps, setSearchEventProps } from "utils/commonUtils";
import { SEARCH_MP_EVENTS_PROPS_NAME } from "modules/candidate/profile/constants/mixpanelConstants";
import HighlightQuery from "./HighlightQuery";

function ExperienceSearchResults({ handleExperienceSelect, handleSearchFeatureUsed }) {
	const [experienceResults, setExperienceResults] = useState([]);
	const [loading, setLoading] = useState(false);

	const getExperienceData = () => {
		setLoading(true);
		return getExperienceSearchResults()
			.then((resp: any) => {
				setLoading(false);
				setExperienceResults(resp?.data?.suggestions || []);
			})
			.catch((e) => {
				console.log(e);
				setLoading(false);
				setExperienceResults([]);
			});
	};

	useEffect(() => {
		getExperienceData();
	}, []);

	if (loading) {
		return (
			<div className="mt-2 w-full text-center">
				<CircularProgress />
			</div>
		);
	}

	return (
		<div className="w-full" id="js-navigation-parent">
			{Array.isArray(experienceResults) &&
				experienceResults?.length > 0 &&
				experienceResults?.map((res) => (
					<div
						key={res.id}
						className="flex w-full cursor-pointer flex-row items-center gap-2 px-4 py-[6px] hover:bg-[#EAF8F4]"
						onMouseDown={() => {
							const searchEventObj = getSearchEventProps();
							const obj = {
								[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]:
									"Suggested",
							};
							const resObj = { ...searchEventObj, ...obj };
							setSearchEventProps(resObj);
							handleSearchFeatureUsed("Suggested");
							handleExperienceSelect(res);
						}}
						onClick={() => {
							const searchEventObj = getSearchEventProps();
							const obj = {
								[SEARCH_MP_EVENTS_PROPS_NAME.SEARCH_FEATURE_USED]:
									"Suggested",
							};
							const resObj = { ...searchEventObj, ...obj };
							setSearchEventProps(resObj);
							handleSearchFeatureUsed("Suggested");
							handleExperienceSelect(res);
						}}
					>
						<div className="flex h-[45px] min-w-[45px] items-center justify-center rounded-md bg-[#F4F2F6] p-1">
							<Search color="disabled" />
						</div>
						<div className="w-full overflow-hidden text-ellipsis whitespace-nowrap text-[#190A28]">
							<div className="overflow-hidden text-ellipsis text-[16px]">
								<HighlightQuery text={res?.display_text} />
							</div>
						</div>
					</div>
				))}
		</div>
	);
}
export default ExperienceSearchResults;
